import { render, staticRenderFns } from "./StockTaking.vue?vue&type=template&id=874fbde0&"
import script from "./StockTaking.vue?vue&type=script&lang=js&"
export * from "./StockTaking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports